import React, {Component} from "react";
import {Col} from "reactstrap";

export class LongLink extends Component {
    render() {
        return <Col md={this.props.md} className="botSpace d-flex align-items-stretch">
            <div className="block longLink">
                <a href={window.location.href}>{window.location.href}</a>
            </div>
        </Col>;
    }
}